<app-breadcrumb [links]="links" current="Ordem Pratas"></app-breadcrumb>
<div class="backgroundColor shark lighten-1">
  <section class="mb-5 top-119 position-relative">
    <div class="container mb-5">
      <div class="row pt-20 pb-10 d-flex justify-content-center">
        <div class="col-12 col-md-6">
          <h1 class="text-white text-shadow">Ordem de Marcas Pratas</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="row col-12 col-md-6 col-lg-5">
            <ul class="row col-12" cdkDropList (cdkDropListDropped)="drop($event)">
              <div *ngFor="let item of marcas; let i = index" cdkDrag class="col-12 pointer-grab">
                <div class="list-group list-unstyled">
                  <li class="list-group-item border border-light text-white m-2" id="{{i}}">{{i+1}} - {{item.nome}}</li>
                </div>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>